import { render, staticRenderFns } from "./AFileMessage.vue?vue&type=template&id=1c1714b5&scoped=true&"
import script from "./AFileMessage.vue?vue&type=script&lang=js&"
export * from "./AFileMessage.vue?vue&type=script&lang=js&"
import style0 from "./AFileMessage.vue?vue&type=style&index=0&id=1c1714b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1714b5",
  null
  
)

export default component.exports